/* eslint-disable no-unused-vars*/
import React from 'react';
/* eslint-enable no-unused-vars*/
import wnumb from 'wnumb';

const formatSalary = (value, salary) => {
  const salaryFormat = wnumb({
    decimals: 0,
    thousand: ',',
    prefix: process.env.REACT_APP_CURRENCY_SYMBOL,
  });

  const salaryHourlyFormat = wnumb({
    decimals: 2,
    thousand: ',',
    prefix: process.env.REACT_APP_CURRENCY_SYMBOL,
  });

  return (salary.type === 'per hour' && !Number.isInteger(value)) ?
    salaryHourlyFormat.to(parseFloat(value)) :
    salaryFormat.to(parseFloat(value));
};

const salaryFormatter = (jobData, listing = false, mvpListing = false) => {
  const useLowerCase = process.env.REACT_APP_USE_LOWER_CASE === 'true';
  const salary = Object.assign({}, jobData.salary);
  if (parseInt(salary.min) === 0 && parseInt(salary.max) === 0) {
    return null;
  }

  if (salary.min) {
    salary.min = formatSalary(parseFloat(salary.min), salary);
  }
  if (salary.max) {
    salary.max = formatSalary(parseFloat(salary.max), salary);
  }

  if (listing) {
    if (salary.min && salary.max && salary.type) {
      return `${salary.min} - ${salary.max} ${useLowerCase ? salary.type.toLowerCase() : salary.type}`;
    }

    return '';
  }

  if (salary.min) {
    if (salary.min === salary.max && salary.type) {
      return `${salary.min} ${useLowerCase ? salary.type.toLowerCase() : salary.type}`;
    } else if (salary.min && salary.max && salary.type && !mvpListing) {
      return `${salary.min} - ${salary.max} ${useLowerCase ? salary.type.toLowerCase() : salary.type}`;
    } else if (salary.min && salary.max && salary.type && mvpListing) {
      return `${salary.min} - ${salary.max} ${useLowerCase ? salary.type.toLowerCase() : salary.type}`;
    } else if (salary.min && salary.type) {
      return `${salary.min} ${useLowerCase ? salary.type.toLowerCase() : salary.type}`;
    } else {
      return salary.min;
    }
  }

  if (!salary.min && !salary.max && salary.fixed) {
    salary.fixed = formatSalary(parseFloat(salary.fixed), salary);
    return `${salary.fixed} ${useLowerCase ? salary.type.toLowerCase() : salary.type}`;
  }

  return null;
};

export {salaryFormatter, formatSalary};
